import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { pdItemPoRef } from '../../../../models/entities/purchaseDemand/purchaseDemandItem';
import CustomModal, { ModalTriggerProps } from '../../../shared/Modal/Modal';
import MuiDataGrid from '../../../shared/MuiDataGrid/MuiDataGrid';
import { Link } from 'react-router-dom';
import { PagesRoutes } from '../../../../routing/PagesRoutes';

type Props = {
    pdItemPoRefs: Array<pdItemPoRef>;
    onCancelCallback?: () => void;
    Trigger: (props: ModalTriggerProps) => JSX.Element;
    localization: any;
};

const PdItemPoRefsModal = ({ pdItemPoRefs, onCancelCallback, Trigger, localization }: Props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const columns: GridColDef[] = [
        {
            field: 'czNumber',
            headerName: '#',
            flex: 1,
            renderCell: (params: GridCellParams) => (
                <Link to={{ pathname: PagesRoutes.PurchaseOrders + '/' + params.row.id }}>{params.value}</Link>
            )
        },
        {
            field: 'quantity',
            headerName: localization.quantity,
            flex: 1
        }
    ];
    
    const handleCancel = () => {
        setIsModalOpen(false);
        if (onCancelCallback) {
            onCancelCallback();
        }
    };
    
    return (
        <CustomModal
            title={{ text: localization.pos_refs }}
            isOpen={isModalOpen}
            Trigger={(props) => <Trigger {...props} onClick={() => setIsModalOpen(true)} />}
            onCancelCallback={handleCancel}
            Content={(setVisible?: React.Dispatch<React.SetStateAction<boolean>>, setConfirm?: React.Dispatch<React.SetStateAction<boolean>>) => {
                return (
                    <MuiDataGrid
                        columns={columns}
                        rows={pdItemPoRefs}
                        disableRowSelectionOnClick
                        disableColumnFilter
                        disableColumnSelector
                        disableColumnMenu
                        autoHeight
                    />
                );
            }}
            width="700px"
        />
    );
};

export default PdItemPoRefsModal;
